import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Stack, Typography } from '@mui/material';

/* Display Warning that not all devices are paired */
const NotAllPaired = () => (
  <Stack sx={{ alignItems: 'center', justifyContent: 'center' }}>
    <Typography sx={{ color: 'warning.main' }}>
      <ErrorOutlineIcon fontSize="large" />
    </Typography>
    <Typography>
      All devices must be paired before proceeding.
    </Typography>
  </Stack>
);

export default NotAllPaired;